import { IAppMenuItem } from "../../../App/Services/RouteService";
import PortfolioTypeCatalogueEntry from "./GenericComponents/PortfolioTypeCatalogueEntry";
import GroupStructureCatalogueEntry from "./GenericComponents/GroupStructureCatalogueEntry";
import LadderAgeCatalogueEntry from "./Pipelines/LadderAgeCatalogueEntry";
import HolidayView from "./General/HolidayView";
import BankCatalogueEntry from "./GenericComponents/BankCatalogueEntry";
import InvestorReferralTypeView from "./Investments/InvestorReferralTypeView";
import InternalRatingCatalogueEntry from "./GenericComponents/InternalRatingCatalogueEntry";
import CommissionTypeCatalogueEntry from "./Pipelines/CommissionTypeCatalogueEntry";
import EntityView from "./Investments/EntityView";
import AssetClassCatalogueEntry from "./GenericComponents/AssetClassCatalogueEntry";
import PRPRateView from "./Pipelines/PRPRateView";
import IDTRateView from "./Pipelines/IDTRateView";
import DocumentTypeCatalogueEntry from "./General/DocumentTypeCatalogueEntry";
import CostRecoveryPremiumCatalogueEntry from "./Pipelines/CostRecoveryPremiumCatalogueEntry";
import ShareTypeCatalogueEntry from "./General/ShareTypeCatalogueEntry";
import IssuerTypeCatalogueEntry from "./General/IssuerTypeCatalogueEntry";
import BankAccountTypeCatalogueEntry from "./Pipelines/BankAccountTypeCatalogueEntry";
import BankAccountView from "../Investments/BankAccountView";
import TitleCatalogueEntry from "./GenericComponents/TitleCatalogueEntry";
import IntraGroupCatalogueEntry from "./GenericComponents/IntraGroupCatalogueEntry";
import CountryCatalogueEntry from "./General/CountryCatalogueEntry";
import SectorCatalogueEntry from "./Reporting/SectorsCatalogueEntry";
import NoteTypeCatalogueEntry from "./GenericComponents/NoteTypeCatalogueEntry";
import AssetTypeCatalogueEntry from "./GenericComponents/AssetTypeCatalogueEntry";
import GLAccountTypeCatalogueEntry from "./GenericComponents/GLAccountTypeCatalogueEntry";
import SARSIDTypeCatalogueEntry from "./General/SARSIDTypeCatalogueEntry";
import LegalEntityTypeCatalogueEntry from "./Classifications/LegalEntityTypeCatalogueEntry";
import PipelineCatalogueEntry from "./Pipelines/PipelineCatalogueEntry";
import RateCatalogueEntry from "./Pipelines/RateCatalogueEntry";
import DwtExemptionCatalogueEntry from "./General/DwtExemptionCatalogueEntry";
import NoticePeriodCatalogueEntry from "./GenericComponents/NoticePeriodCatalogueEntry";
import ContactTypeCatalogueEntry from "./General/ContactTypeCatalogueEntry";
import SARSNatureOfPersonCatalogueEntry from "./General/SARSNatureOfPersonCatalogueEntry";
import ProductTypeCatalogueEntry from "./General/ProductTypeCatalogueEntry";
import MergeTemplateCatalogueEntry from "./General/MergeTemplateCatalogueEntry";
import LadderProjectionView from "./Pipelines/LadderProjectionView";
import DistributionTypeCatalogueEntry from "./General/DistributionTypeCatalogueEntry";

export const catalogueRoutes = {

    classification: [
        { name: "Legal Entity Types", component: LegalEntityTypeCatalogueEntry },
        { name: "Asset Types", component: AssetTypeCatalogueEntry },
        { name: "Portfolio Types", component: PortfolioTypeCatalogueEntry },
        { name: "Product Types", component: ProductTypeCatalogueEntry },
        { name: "Distribution Types", component: DistributionTypeCatalogueEntry },
    ] as IAppMenuItem[],

    reporting: [
        { name: "Groups", component: GroupStructureCatalogueEntry },
        { name: "Intra Groups", component: IntraGroupCatalogueEntry },
        { name: "Sectors", component: SectorCatalogueEntry },
        { name: "Asset Classes", component: AssetClassCatalogueEntry },
    ] as IAppMenuItem[],

    pipeline: [
        { name: "Pipelines", component: PipelineCatalogueEntry },
        { name: "Commission Types", component: CommissionTypeCatalogueEntry },
        { name: "Rates", component: RateCatalogueEntry },
        { name: "Ladder Ages", component: LadderAgeCatalogueEntry },
        { name: "Ladder Projections", path: "/ladder-projections", component: LadderProjectionView },
        { name: "PRP Rates", path: "/prpRates", component: PRPRateView },
        { name: "IDT Rates", path: "/idtRates", component: IDTRateView },
        { name: "Cost Recovery Premiums", component: CostRecoveryPremiumCatalogueEntry },
        { name: "Bank Account Types", component: BankAccountTypeCatalogueEntry }
    ] as IAppMenuItem[],

    general: [
        { name: "Holidays", path: "/holidays", component: HolidayView },
        { name: "Countries", component: CountryCatalogueEntry },
        { name: "Banks", component: BankCatalogueEntry },
        { name: "Document Types", component: DocumentTypeCatalogueEntry },
        { name: "Share Types", component: ShareTypeCatalogueEntry },
        { name: "Issuer Types", component: IssuerTypeCatalogueEntry },
        { name: "Titles", component: TitleCatalogueEntry },
        { name: "Note Types", component: NoteTypeCatalogueEntry },
        { name: "GL Account Types", component: GLAccountTypeCatalogueEntry },
        { name: "SARS ID Types", component: SARSIDTypeCatalogueEntry },
        { name: "DWT Exemptions", component: DwtExemptionCatalogueEntry },
        { name: "Contact Types", component: ContactTypeCatalogueEntry },
        { name: "SARS Nature Of Person", component: SARSNatureOfPersonCatalogueEntry }
    ] as IAppMenuItem[],

    investment: [
        { name: "Investor Referral Types", path: "/investorReferralTypes", component: InvestorReferralTypeView },
        { name: "Internal Ratings", component: InternalRatingCatalogueEntry },
        { name: "Entities", path: "/entities", component: EntityView },
        { name: "Bank Accounts", path: "/bankAccounts", component: BankAccountView },
        { name: "Notice Periods", component: NoticePeriodCatalogueEntry },
        { name: "Merge Templates", component: MergeTemplateCatalogueEntry },
    ] as IAppMenuItem[]
}